import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export function NewLeadsCard() {
  const [filter, setFilter] = useState("This Week");
  const [hover, setHover] = useState(null);

  const days = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];

  const dataset = {
    "This Week": [
      [22,29,13,32,32,32,32],
      [22,29,13,32,32,32,32],
      [29,13,32,32,32,32,32],
      [20,13,32,32,32,32,32],
    ],
    "This Month": [
      [10,20,15,25,30,20,10],
      [15,25,20,30,35,25,15],
      [20,30,25,35,40,30,20],
      [25,35,30,40,45,35,25],
    ],
    "This Year": [
      [5,10,15,20,25,30,35],
      [10,15,20,25,30,35,40],
      [15,20,25,30,35,40,45],
      [20,25,30,35,40,45,50],
    ]
  };

  const data = dataset[filter];

  const yAxis = [120, 80, 60, 40, 20, 0];

  const getColor = (val) => {
    if (val >= 35) return "dark";
    if (val >= 25) return "mid";
    return "light";
  };

  return (
    <Card className="nl-card h-100">
      <Card.Header className="nl-header card-header-custom">
        <h5>New Leads</h5>

        <Dropdown>
          <Dropdown.Toggle className="nl-btn nl-toggle text-dark">
            <FiCalendar className="me-1"/>
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="nl-menu">
            {Object.keys(dataset).map((item)=>(
              <Dropdown.Item key={item} onClick={()=>setFilter(item)}>
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>

        <div className="nl-wrapper">
          
          {/* 🔥 Y AXIS */}
          <div className="nl-yaxis">
            {yAxis.map((y)=>(
              <span key={y}>{y}</span>
            ))}
          </div>

          {/* 🔥 MAIN CONTENT */}
          <div className="nl-content">

            <div className="nl-top-value">75</div>

            <div className="nl-grid">
              {data.map((row, i) => (
                <div key={i} className="nl-row">
                  {row.map((val, j) => (
                    <div
                      key={j}
                      className={`nl-cell ${getColor(val)} ${j===2 ? "selected" : ""}`}
                      onMouseEnter={()=>setHover({val})}
                      onMouseLeave={()=>setHover(null)}
                    >
                      {val}
                    </div>
                  ))}
                </div>
              ))}
            </div>

            {/* TOOLTIP */}
            {hover && (
              <div className="nl-tooltip">
                <b>40:</b> {hover.val}
              </div>
            )}

            {/* DAYS */}
            <div className="nl-days">
              {days.map((d,i)=>(
                <span className={i===2 ? "active-day":""}>{d}</span>
              ))}
            </div>

          </div>
        </div>
      </Card.Body>

      <style>{`
        .nl-card {
          border:2px solid #e5e7eb;
          border-radius:5px;
        }
               .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

        .nl-header {
          display:flex;
          justify-content:space-between;
          align-items:center;
        }

        .nl-btn {
          background:#fff;
          border:1px solid #e5e7eb;
          font-size:14px;
        }

        
        .nl-btn:hover {
           border-color: #f97316 !important;
          color: #f97316 !important;
           background: #f9fafb;
          border: 1px solid #e5e7eb;
        }
        .nl-toggle::after { display:none; }

        .nl-wrapper {
          display:flex;
          gap:10px;
        }

        /* 🔥 Y AXIS */
        .nl-yaxis {
          display:flex;
          flex-direction:column;
          justify-content:space-between;
          font-size:12px;
          color:#6b7280;
          padding-top:20px;
        }

        .nl-content {
          flex:1;
          position:relative;
        }

        .nl-top-value {
          width:50px;
          height:40px;
          background:#f97316;
          color:#fff;
          font-weight:600;
          display:flex;
          align-items:center;
          justify-content:center;
          border-radius:6px;
          margin:0 auto 10px;
        }

        .nl-grid {
          display:flex;
          flex-direction:column;
          gap:8px;
          align-items:center;
        }

        .nl-row {
          display:flex;
          gap:8px;
        }

        .nl-cell {
          width:42px;
          height:42px;
          border-radius:6px;
          display:flex;
          align-items:center;
          justify-content:center;
          font-size:13px;
          font-weight:500;
          color:#fff;
        }

        .light { background:#d1d5db; }
        .mid { background:#f4c7ab; }
        .dark { background:#f97316; }

        .selected {
          outline:2px solid #94a3b8;
          transform:translateY(-2px);
        }

        .nl-tooltip {
          position:absolute;
          background:#fff;
          border-radius:8px;
          padding:8px 12px;
          box-shadow:0 4px 12px rgba(0,0,0,0.1);
          top:50%;
          left:50%;
          transform:translate(-50%,-50%);
          font-size:14px;
        }

        .nl-days {
          display:flex;
          justify-content:space-between;
          margin-top:12px;
          font-size:13px;
          color:#6b7280;
        }

        .active-day {
          background:#e5e7eb;
          padding:6px 10px;
          border-radius:6px;
        }

      `}</style>
    </Card>
  );
}